import {map} from 'rxjs/operators';
import {Injectable} from "@angular/core";
import {AssetsProxy} from "./assets.proxy";
import {LogManager} from '../log/log.manager';
import {LogCat} from '../log/log.categories';
import {HttpObservable} from '../http-helpers/http.wrapper';

/**
 ****************************************************************
 * Service class for asset calls.
 *
 * Created by Shai Zelman on 03/05/2020.
 ****************************************************************
 */
@Injectable({
	providedIn: "root"
})
export class AssetService {
	constructor(private assetProxy: AssetsProxy) {}

	public getStaticAssetByCode(code: string): HttpObservable<string> {
		LogManager.debug(LogCat.Asset.Service, "Get static asset by code.", code);

		return this.assetProxy.getStaticAssetByCode(code).pipe(map((x) => {
			return URL.createObjectURL(x);
		}));
	}
}
